// Make sure this matches your environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  // Auth endpoints
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    register: `${API_BASE_URL}/api/auth/register`,
    verify: `${API_BASE_URL}/api/auth/verify`,
    refresh: `${API_BASE_URL}/api/auth/refresh`,
    logout: `${API_BASE_URL}/api/auth/logout`,
  },
  
  // Legacy endpoints (to be deprecated)
  recipes: `${API_BASE_URL}/api/recipes`,
  users: `${API_BASE_URL}/api/users`,
  clientProfiles: `${API_BASE_URL}/api/client-profiles`,
  portal: `${API_BASE_URL}/api/portal`,
  planes: `${API_BASE_URL}/api/planes`,
  plans: `${API_BASE_URL}/api/plans`,
  planRecetas: `${API_BASE_URL}/api/plan-recetas`,
  
  // AI-powered recipe parsing
  ai: {
    parseText: `${API_BASE_URL}/api/ai/parse-text`,
    parseImage: `${API_BASE_URL}/api/ai/parse-image`,
  },

  // New optimized endpoints
  mealPlans: {
    base: `${API_BASE_URL}/api/meal-plans`,
    byId: (id) => `${API_BASE_URL}/api/meal-plans/${id}`,
    create: `${API_BASE_URL}/api/meal-plans`,
    update: (id) => `${API_BASE_URL}/api/meal-plans/${id}`,
    patchEstado: (id) => `${API_BASE_URL}/api/meal-plans/${id}/estado`,
    patchDiaSlot: (id, dia, slot) => `${API_BASE_URL}/api/meal-plans/${id}/dias/${dia}/${slot}`,
    delete: (id) => `${API_BASE_URL}/api/meal-plans/${id}`,
    weekly: `${API_BASE_URL}/api/meal-plans/weekly`,
    shoppingList: (id) => `${API_BASE_URL}/api/meal-plans/${id}/shopping-list`,
    nutrition: (id) => `${API_BASE_URL}/api/meal-plans/${id}/nutrition`,
    preferences: (id) => `${API_BASE_URL}/api/meal-plans/${id}/preferences`,
    advisorGenerate: `${API_BASE_URL}/api/meal-plans/advisor/generate`,
  }
};

export default API_BASE_URL;